import React from "react";
import { cn, formatDateToLocalInputValue } from "../../../../lib/utils";

interface IDateCellProps {
  value?: string;
  isEditable?: boolean;
  onChange?: (value: string) => void;
  className?: string;
  inputClassName?: string;
}

const DateCell: React.FC<IDateCellProps> = ({
  value,
  isEditable,
  onChange,
  className,
  inputClassName,
}) => {
  if (!isEditable) {
    return (
      <div className={cn("px-2 py-1 text-sm", className)}>{value || "-"}</div>
    );
  }

  return (
    <input
      type="date"
      value={formatDateToLocalInputValue(value)}
      onChange={(e) => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
      className={cn(
        "p-1 flex-1 text-sm w-full",
        "border border-transparent rounded",
        "focus:outline-none focus:ring-0",
        "focus:bg-[#F3F4F6]",
        "focus:[&::-webkit-datetime-edit]:bg-[#F3F4F6]",
        "focus:[&::-webkit-datetime-edit-fields-wrapper]:bg-[#F3F4F6]",
        inputClassName
      )}
    />
  );
};

export default DateCell;
